<div class="nav-button p-4" routerLinkActive="active" routerLink="/{{link}}">
    <mat-icon>{{ icon }}</mat-icon>
    <div class="label">{{ label }}</div>
</div>
